import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Radio from "@mui/material/Radio";

export default function RecipeReviewCard(props) {
  const { selectedValue, setSelectedValue } = props;

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <Card>
      <CardHeader
        avatar={
          <Radio
            checked={selectedValue === "a"}
            onChange={handleChange}
            value="a"
            name="radio-button-demo"
            inputProps={{ "aria-label": "A" }}
          />
        }
        title={<strong>Owner</strong>}
        subheader="Provides full access to Gcp services and resources."
      />
    </Card>
  );
}
